import React, { FC } from 'react';

import { IconInfoOutline } from 'components/icons/info-outline';

import { ModifierInfoIconButton } from './info-icon-with-button.styled';
import { ModifierWithArrowButtonProps } from './types';

export const ModifierWithInfoButton: FC<ModifierWithArrowButtonProps> = ({
  onClick,
  withBorder = false,
  'data-testid': dataTestId,
}) => {
  return (
    <ModifierInfoIconButton data-testid={dataTestId} onClick={onClick} withBorder={withBorder}>
      <IconInfoOutline />
    </ModifierInfoIconButton>
  );
};
